<ion-header>
  <ion-toolbar>
    <ion-title>{{recipient}}</ion-title>
    <ion-buttons slot="end">
      <ion-button *ngIf="displayProfileButton" (click)="openProfileModal(recipient)" color="tertiary">Profile<ion-icon name="person-circle"></ion-icon></ion-button>
      <ion-button (click)="cancel()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-textarea
    label="Message"
    placeholder="Add your message here"
    [autoGrow]="true"
    [ngModel]="(messageText$ | async)"
    maxlength="500"
    (ngModelChange)="trackNewMessageText($event)"
  >
  </ion-textarea>
  <ion-button (click)="sendMessage()" color="success" [disabled]="!((messageText$ | async).length > 0)">
    <ion-label>Send</ion-label>
  </ion-button>
  <ion-list *ngIf="(getConversation() | async) as conversation">
    <div *ngFor="let message of conversation">
      <ion-card
        [color]="sentByCurrentUser(message) ? 'primary' : 'medium'"
        class="message-card"
        [ngClass]="{'message-sent': sentByCurrentUser(message), 'message-received': !sentByCurrentUser(message)}"
        (dblclick)="onMessageDoubleClick(message.timestamp, $event)">
        <ion-card-content>
          {{message.text}}<br>
          <div *ngIf="sentByCurrentUser(message) && selectedMessageId === message.timestamp">
            {{formatTimestamp(message.timestamp)}}<br>
            <ion-chip color="danger" (click)="deleteMessage(message.messageId)">
              <ion-label>Delete</ion-label>
              <ion-icon name="close"></ion-icon>
            </ion-chip>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </ion-list>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMore($event)">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Loading more messages..."
    ></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>